// Safely tear down a Leaflet map instance.
//
// Leaflet has a long-standing crash: if map.remove() runs while a
// zoom/pan animation is still in flight, the queued
// `_onZoomTransitionEnd` handler fires AFTER the map panes are gone and
// reads `_leaflet_pos` off `undefined`:
//
//   TypeError: Cannot read properties of undefined (reading '_leaflet_pos')
//       at getPosition → _getMapPanePos → _getNewPixelOrigin → _move
//       → _onZoomTransitionEnd
//
// This happens when the user navigates away (React unmounts the map's
// effect → cleanup calls map.remove()) right after a zoom — common on
// fast taps. The fix is to neutralise any in-flight animation and detach
// listeners BEFORE removing:
//   1. stop() cancels any running pan/zoom animation.
//   2. disable the zoom-animation flag so no new transitionend fires.
//   3. swallow any residual error from remove() as a last resort.
export function safeRemoveMap(map) {
  if (!map) return;
  try {
    // Cancel any in-progress pan/zoom so no transitionend callback is
    // queued against panes we're about to destroy.
    if (typeof map.stop === "function") map.stop();
    // Belt-and-suspenders: turn off zoom animation so Leaflet won't wait
    // on a CSS transitionend that would fire post-teardown.
    if (map.options) map.options.zoomAnimation = false;
    // Drop all listeners (including the internal zoom-transition one).
    if (typeof map.off === "function") map.off();
  } catch (_) { /* ignore — we're tearing down anyway */ }
  try {
    map.remove();
  } catch (_) { /* already-detached pane etc. — safe to ignore on unmount */ }
}
